import { request } from "../utils/request.js"

export const otherIncomeOrder_exportForManage = (pojo, args) => request({
    url: 'otherIncomeOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const otherIncomeOrder_findPageForManage = (pojo, args) => request({
    url: 'otherIncomeOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const otherIncomeOrder_findPageListForManage = (pojo, args) => request({
    url: 'otherIncomeOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const otherIncomeOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'otherIncomeOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const otherIncomeOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'otherIncomeOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const otherIncomeOrder_saveIntoDraft = (pojo, args) => request({
    url: 'otherIncomeOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const otherIncomeOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'otherIncomeOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const otherIncomeOrder_update = (pojo, args) => request({
    url: 'otherIncomeOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const otherIncomeOrder_updateAndSubmit = (pojo, args) => request({
    url: 'otherIncomeOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const otherIncomeOrder_submitById = (id, args) => request({
    url: 'otherIncomeOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const otherIncomeOrder_deleteById = (id, args) => request({
    url: 'otherIncomeOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const otherIncomeOrder_approval = (pojo, args) => request({
    url: 'otherIncomeOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const otherIncomeOrder_findById = (id, args) => request({
    url: 'otherIncomeOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/otherIncomeOrder.js